
export { ShoppingBagButton } from "/codebuild/output/src3644705884/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"